import { FilterGroupType } from '../Components/ProductFiltering/types/FilterGroupType';
import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_FILTERING_UPDATE_FILTERS,
  PRODUCT_FILTERING_SET_SORTING,
  PRODUCT_FILTERING_UPDATE_PENDING,
  MCS_STRUCTURE_UPDATE,
  MCS_ROOTPAGE_UPDATE,
  MCS_ROOTTITLE_UPDATE,
  MCS_METAROOTTITLE_UPDATE,
} from '../constants';
import { get } from '../Services/http';
import {
  setIsLoadingProductListing,
  setProducts,
} from './ProductListing.action';

let abortController = null;

export const queryProductFiltering =
  (productFilteringState = null, isInitialLoad = false) =>
  async (dispatch, getState) => {
    try {
      productFilteringState ??= getState().productFiltering;
      const productListingState = getState().productListing;

      dispatch(toggleUpdatePending(true));

      // Show skeleton cards before loading the new products
      if (!isInitialLoad) {
        dispatch(setIsLoadingProductListing(true));
        dispatch(
          setProducts(Array.from({ length: productListingState.pageSize }))
        );
      }

      // Cancel the last request
      if (abortController) {
        abortController.abort();
      }
      abortController = new AbortController();

      const queryString = getProductFilteringAsQueryString(
        productFilteringState
      );

      const response = await get(
        `/api/productfiltering?${queryString}`,
        abortController
      );

      if (response.ok) {
        const isJson = response.headers
          .get('content-type')
          ?.includes('application/json');
        if (isJson) {
          let data = await response.json();
          if (isInitialLoad) {
            delete data.productListing;
          }

          //MCS
          const structure = data.mcsStructure;
          const rootPageUrl = data.mcsRootPageUrl;
          const rootPageTitle = data.mcsRootPageTitle;
          const rootPageMetaTitle = data.mcsRootPageMetaTitle;
          const rootPageDescription = data.mcsRootPageDescription;
          const filterCriteria = toFilterCriteria(data.filters);

          ModifyResultForMCS(
            filterCriteria,
            structure,
            rootPageUrl,
            rootPageTitle,
            rootPageDescription,
            rootPageMetaTitle,
            queryString,
            dispatch
          ); //MCS

          dispatch(receiveProductFiltering(data, isInitialLoad));
        }
      }
    } catch (err) {
      // TODO Error handling, not in MOX-86
      console.log(err);
    } finally {
      dispatch(setIsLoadingProductListing(false));
      dispatch(toggleUpdatePending(false));
    }
  };

const toFilterCriteria = (groups) =>
  groups
    .map((group) =>
      group.selectedOptions
        .filter((val) =>
          group.asSlider
            ? group.selectedOptions.length == 2
            : val && val.length > 0
        )
        .map(
          (val) =>
            `${encodeURIComponent(group.id)}=${encodeURIComponent(val)}`
        )
    )
    .reduce((flat, current) => [...flat, ...current], []);

export const IsMcsPageResult = (payload) => (dispatch, getState) => {
  var filterCriteria = toFilterCriteria(payload.filters);
  const q = filterCriteria.join(';');
  var filters = q.replaceAll('=', ':');
  var cleanedFilters = decodeURIComponent(filters);
  var jsonArray = JSON.parse(payload.mcsStructure);

  if (!jsonArray) {
    jsonArray = [];
  }

  var matchingPageByFilter = jsonArray.find(
    (obj) => obj.Filter == cleanedFilters
  );
  return matchingPageByFilter ? matchingPageByFilter : null;
};

export const ModifyResultForMCS = (
  filterCriteria,
  mcsStructure,
  rootpageUrl,
  rootPageTitle,
  rootPageDescription,
  rootPageMetaTitle,
  query,
  dispatch
) => {
  //MCS

  const q = filterCriteria.join(';');
  var filters = q.replaceAll('=', ':');
  var cleanedFilters = decodeURIComponent(filters);
  var jsonArray = JSON.parse(mcsStructure);

  if (!jsonArray) {
    jsonArray = [];
  }

  var matchingPageByFilter = jsonArray.find(
    (obj) => obj.Filter == cleanedFilters
  );
  var matchingMCSPage = matchingPageByFilter ? matchingPageByFilter : null;

  if (matchingMCSPage && matchingMCSPage.Url && cleanedFilters !== '') {
    var separator =
      window.location.href
        .replace(window.location.search, '')
        .endsWith('/') || matchingMCSPage.Url.startsWith('/')
        ? ''
        : '/';
    const url =
      window.location.origin +
      rootpageUrl +
      separator +
      matchingMCSPage.Url;
    if (window.location.pathname !== matchingMCSPage.Url) {
      window.history.pushState('search', 'Search Page', url);
      var header = document.getElementById('mcs-current-category-header');
      if (header) {
        header.innerHTML = matchingMCSPage.Title;
      }
      var ingress = document.getElementById(
        'mcs-current-category-description'
      );
      if (ingress) {
        ingress.innerHTML = matchingMCSPage.Description;
      }
      document.title = matchingMCSPage.MetaTitle;
    }
  } else {
    if (rootpageUrl) {
      const url =
        window.location.origin +
        rootpageUrl +
        `${query ? '?' : ''}${query}`;
      if (rootpageUrl != window.location.pathname) {
        window.history.pushState('search', 'Search Page', url);

        var header = document.getElementById(
          'mcs-current-category-header'
        );
        if (header && rootPageTitle) {
          header.innerHTML = rootPageTitle;
        }
        var ingress = document.getElementById(
          'mcs-current-category-description'
        );
        if (ingress && rootPageDescription) {
          ingress.innerHTML = rootPageDescription;
        }
        //metadata
        if (rootPageMetaTitle) {
          document.title = rootPageMetaTitle;
        }
      }
    }
  }
};

export const receiveProductFiltering = (productFiltering, isInitialLoad = undefined ) => ({
  type: PRODUCT_FILTERING_RECEIVE,
  payload: productFiltering,
  isInitialLoad,
});

export const getProductFilteringAsQueryString = (
  productFilteringState
) => {
  const currentSearchParams = new URLSearchParams(location.search);
  const searchParams = new URLSearchParams();

  // Keep certain params from the current query
  const paramsToKeep = ['page', 'q', 'count'];
  paramsToKeep.forEach(
    (key) =>
      currentSearchParams.has(key) &&
      searchParams.append(key, currentSearchParams.get(key))
  );

  // Loop each filter, add each selected option, checkboxes (Ignore for MCS)
  productFilteringState.filters
    ?.filter(
      (f) =>
        f.selectedOptions.length > 0 &&
        f.filterGroupType != FilterGroupType.Range &&
        f.filterGroupType != FilterGroupType.PriceRange
    )
    .forEach((filter) =>
      filter.selectedOptions.forEach((selectedOption) => {
        searchParams.append(filter.id, selectedOption);
      })
    );

  // Range filters
  productFilteringState.filters
    ?.filter(
      (f) =>
        (f.filterGroupType == FilterGroupType.Range ||
          f.filterGroupType == FilterGroupType.PriceRange) &&
        f.selectedOptions.length == 2
    )
    .forEach((filter) => {
      searchParams.append(
        filter.id,
        `${filter.selectedOptions[0]}-${filter.selectedOptions[1]}`
      );
    });

  // Sorting
  const selectedSorting =
    productFilteringState.sortCriteria?.sortItems?.find((s) => s.selected);

  if (selectedSorting && selectedSorting.query) {
    searchParams.append('sort_by', selectedSorting.sortBy);
    searchParams.append('sort_direction', selectedSorting.sortDirection);
  }

  return searchParams.toString();
};

export const onOptionChanged =
  (filterId, optionId) => (dispatch, getState) => {
    const filters = [...getState().productFiltering.filters]; // create copy of filters list to not modify the state
    const filterIndex = filters.findIndex((f) => f.id == filterId);
    if (filterIndex == -1) return;

    const { singleSelect, selectedOptions } = filters[filterIndex];
    const optionIndex = selectedOptions.indexOf(optionId);
    const isOptionSelected = optionIndex != -1;
    let updatedSelectedOptions = [];

    if (singleSelect) {
      updatedSelectedOptions = isOptionSelected ? [optionId] : [];
    } else {
      updatedSelectedOptions = isOptionSelected
        ? [
            // selected, remove it from the list
            ...selectedOptions.slice(0, optionIndex),
            ...selectedOptions.slice(optionIndex + 1),
          ]
        : [...selectedOptions, optionId]; // Not selected, add it to selected list
    }
    filters[filterIndex].selectedOptions = updatedSelectedOptions;

    dispatch(updateProductFilteringFilters(filters));
  };

export const onRangeChanged =
  (filterId, values) => (dispatch, getState) => {
    const filters = [...getState().productFiltering.filters]; // create copy of filters list to not modify the state
    const filterIndex = filters.findIndex((f) => f.id == filterId);
    if (
      filterIndex == -1 ||
      (filters[filterIndex].filterGroupType != FilterGroupType.Range &&
        filters[filterIndex].filterGroupType != FilterGroupType.PriceRange)
    )
      return;

    filters[filterIndex].selectedOptions = values;

    dispatch(updateProductFilteringFilters(filters));
  };

const updateProductFilteringFilters = (filters) => ({
  type: PRODUCT_FILTERING_UPDATE_FILTERS,
  payload: filters,
});

export const toggleUpdatePending = (updatePending) => ({
  type: PRODUCT_FILTERING_UPDATE_PENDING,
  payload: {
    updatePending,
  },
});

export const onSortItemSelected = (sortItem) => (dispatch) => {
  dispatch({
    type: PRODUCT_FILTERING_SET_SORTING,
    payload: sortItem,
  });
  dispatch(queryProductFiltering());
};

export const clearAllFilters = () => (dispatch, getState) => {
  const productFilteringState = getState().productFiltering;
  const filtersCopy = Object.assign([], productFilteringState.filters);
  for (let filter of filtersCopy) {
    filter.selectedOptions = [];
  }
  dispatch(
    queryProductFiltering({
      ...productFilteringState,
      filters: filtersCopy,
    })
  );
};

export const clearFilterGroup =
  (filterGroupId) => (dispatch, getState) => {
    const productFilteringState = getState().productFiltering;
    const filtersCopy = Object.assign([], productFilteringState.filters);
    const filterGroup = filtersCopy.find((f) => f.id == filterGroupId);
    if (!filterGroup) return;
    filterGroup.selectedOptions = [];
    dispatch(
      queryProductFiltering({
        ...productFilteringState,
        filters: filtersCopy,
      })
    );
  };

//MCS actions
export const saveMCSStructure = (structure) => ({
  type: MCS_STRUCTURE_UPDATE,
  payload: {
    mcsStructure: structure,
  },
});

export const saveMCSRootPageUrl = (rootPageUrl) => ({
  type: MCS_ROOTPAGE_UPDATE,
  payload: {
    mcsRootPageUrl: rootPageUrl,
  },
});

export const saveMCSRootPageTitle = (rootPageTitle) => ({
  type: MCS_ROOTTITLE_UPDATE,
  payload: {
    mcsRootPageTitle: rootPageTitle,
  },
});
export const saveMCSRootPageDescription = (rootPageDescription) => ({
  type: MCS_ROOTTITLE_UPDATE,
  payload: {
    mcsRootPageDescription: rootPageDescription,
  },
});
export const saveMCSRootPageMetaTitle = (rootPageMetaTitle) => ({
  type: MCS_METAROOTTITLE_UPDATE,
  payload: {
    mcsRootPageMetaTitle: rootPageMetaTitle,
  },
});
